import axios from 'axios'
import { apiLoginUrl } from '@/config.js';


const axiosLoginImpl = axios.create({
	baseURL: apiLoginUrl,
	timeout: 100000,
	crossDomain: true,
	headers: {
		'Content-Type': 'application/json'
	}
})

axiosLoginImpl.interceptors.request.use(
	(config) => {
		
		config.headers['Content-Type'] = 'application/json';
		config.headers['Access-Control-Allow-Credentials'] = 'true';
		config.headers['Access-Control-Expose-Headers'] = "Access-Control-*";
        config.headers['Access-Control-Allow-Headers'] = "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept";
        config.headers['Access-Control-Allow-Methods'] = "GET, POST, PUT, DELETE, OPTIONS, HEAD";
        config.headers['Access-Control-Allow-Origin'] = "*";
		config.headers['Allow'] = "GET, POST, PUT, DELETE, OPTIONS, HEAD";
		
		config.baseURL = apiLoginUrl;
        
		//config.data = {}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export default axiosLoginImpl